import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import PostAddOutlinedIcon from '@mui/icons-material/PostAddOutlined';
import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined';

import { ICONS } from '../icons';
import { USER_ROLES } from '../constants';

export const useSidebarData = () => {
  const { t } = useTranslation('sidebar');

  return useMemo(
    () => [
      {
        label: t('projects'),
        url: '/projects',
        icon: ICONS.Docs,
        permissions: [
          USER_ROLES.GLOBAL_USER,
          USER_ROLES.GLOBAL_ADMIN,
          USER_ROLES.ROLE_CUSTOMER,
          USER_ROLES.COMPANY_ADMIN,
        ],
      },
      {
        label: t('customers'),
        url: '/customers',
        icon: ICONS.Business,
        permissions: [USER_ROLES.GLOBAL_ADMIN],
      },
      {
        label: t('users'),
        url: '/users',
        icon: ICONS.Users,
        permissions: [USER_ROLES.GLOBAL_ADMIN],
      },
      {
        label: t('aiPlayground'),
        url: '/playground',
        icon: SmartToyOutlinedIcon,
        permissions: [USER_ROLES.GLOBAL_USER, USER_ROLES.GLOBAL_ADMIN],
      },
      {
        label: t('projectRequest'),
        url: '/project-request',
        icon: PostAddOutlinedIcon,
        permissions: [
          USER_ROLES.GLOBAL_USER,
          USER_ROLES.GLOBAL_ADMIN,
          USER_ROLES.ROLE_CUSTOMER,
          USER_ROLES.COMPANY_ADMIN,
        ],
      },
      {
        label: t('settings'),
        url: '/settings/id8',
        icon: ICONS.Settings,
        isStrokeIcon: true,
        selectedRoutes: [
          '/settings/sonar',
          '/settings/resonance',

          '/settings/scout',
          '/settings/scout/add',
          '/settings/scout/edit',

          '/settings/id8',
          '/settings/id8/',
          '/settings/id8/create-agent',
          '/settings/id8/edit-agent/:id',

          '/settings/activ8',
        ],
        permissions: [USER_ROLES.GLOBAL_ADMIN],
      },
    ],
    [t],
  );
};
